interface IDetailsProspect {
  mail?: string | undefined;
  phone?: string | undefined;
}

export function RenderDetailsProspect({ mail, phone }: IDetailsProspect) {
  return (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <div className="d-flex align-items-center">
            <i className="material-icons-outlined float-start m-3 color-text">
              mail
            </i>
            <span>
              <a href="mailto:joao.batista@gmail.com">{mail}</a>
            </span>
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
          <div className="d-flex align-items-center">
            <i className="material-icons-outlined float-start m-3 color-text">
              call
            </i>
            <span>
              <a
                href={`https://wa.me/${phone.replace(/\D/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {phone}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
